import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsCheckCircleOnLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#actions_check_circle_on_large_svg__clip0_138_162)">
        <path
          d="M24 0a24 24 0 1024 24A24.032 24.032 0 0024 0zM8.99 27.34l8.71 8.7 23.29-23.29v2.83L17.7 38.87l-8.71-8.71v-2.82z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="actions_check_circle_on_large_svg__clip0_138_162">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgActionsCheckCircleOnLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgActionsCheckCircleOnLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsCheckCircleOnLarge;
